module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/equipment-091fbf8b.png";